import { createPortal } from 'react-dom';
import { useState, useEffect, useRef } from 'react';

import "./style.css"

function TooltipPortal({ children, targetRef, show }) {
    const [position, setPosition] = useState({ top: 0, left: 0 });
    const [isAbove, setIsAbove] = useState(false); // Nouvel état pour tracker si le tooltip est au-dessus
    const tooltipRef = useRef(null);

    useEffect(() => {
        if (!show || !targetRef.current || !tooltipRef.current) return;

        const targetRect = targetRef.current.getBoundingClientRect();
        const tooltipRect = tooltipRef.current.getBoundingClientRect();

        // Positionne le tooltip EN DESSOUS de l'icône par défaut
        let top = targetRect.bottom + 8;
        let left = targetRect.right - tooltipRect.width;
        let above = false;

        // Vérifie si le tooltip sort de l'écran en bas
        if (top + tooltipRect.height > window.innerHeight) {
            top = targetRect.top - tooltipRect.height - 8; // Met au-dessus
            above = true;
        }

        // Vérifie si le tooltip sort de l'écran à droite
        if (left < 0) {
            left = 0;
        }

        setPosition({ top, left });
        setIsAbove(above);
    }, [show, targetRef]);

    if (!show) return null;

    return createPortal(
        <ul
            ref={tooltipRef}
            className={`awards_tooltip_portal ${isAbove ? 'tooltip-above' : 'tooltip-below'}`}
            style={{
                position: 'fixed',
                top: `${position.top}px`,
                left: `${position.left}px`,
                zIndex: 10,
                margin: 0
            }}
        >
            {children}
        </ul>,
        document.body
    );
}

export default TooltipPortal;